import { downgradeComponent } from "@angular/upgrade/static";
import { FleetNavigationModule } from "@app/main/modules/fleet/fleet.navigation";
import { AccountFeatures } from "@enums/account/AccountFeature";
import { AuthorizationService } from "@services/authorization.service";
import { HighChartsService } from "@services/highcharts.service";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { AlcolockService } from "./alcolockCompliance/alcolock.service";
import { AlcolockComplianceComponent } from "./alcolockCompliance/alcolockCompliance.component";
import { ComplianceRingComponent } from "./alcolockCompliance/complianceRing.component";
import { TachoComplianceComponent } from "./tacho-compliance-page/tacho-compliance-page.component";
import { TachoController } from "./tacho.controller";

export class Config {

    constructor($stateProvider: StateProvider) {

        $stateProvider.state(FleetNavigationModule.Tachograph, {
            url: "/tachograph/:page/:option",
            views: {
                "content@app": {
                    component: "tachoCompliance"
                }
            },
            params: {
                page: { squash: true, value: null, dynamic: true },
                option: { squash: true, value: null, dynamic: true }
            },
            data: { translation: "Common.Tachograph", subtitleTranslationKey:  "TachoCompliancePage.Subtitle"  },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([], [AccountFeatures.Tacho])]
            }
        });

        $stateProvider.state(FleetNavigationModule.Breathalock, {
            url: "/breathalock/:page/:option",
            views: {
                "content@app": {
                    component: "alcolockCompliance"
                }
            },
            params: {
                page: { squash: true, value: null, dynamic: true },
                option: { squash: true, value: null, dynamic: true }
            },
            data: { translation: "Common.Breathalock" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([], [AccountFeatures.Breathalock])]
            }
        });
    }
}

angular
    .module("app.components.tacho", [
        "ui.router",
        "ngMaterial",
        "highcharts-ng"
    ])
    .config(["$stateProvider", Config])

    .controller("tachoController", TachoController)

    .directive("tachoCompliance", downgradeComponent({ component: TachoComplianceComponent }))
    .service("alcolockService", AlcolockService)
    .component("alcolockCompliance", new AlcolockComplianceComponent())
    .component("complianceRing", new ComplianceRingComponent())
    .service("highChartsService", HighChartsService);

